import { type ReactNode } from "react";
import BackLink from "./BackLink";

// Main container component
interface PageHeaderProps {
  children: ReactNode;
}

function PageHeader({ children }: PageHeaderProps) {
  return <div className="mb-6">{children}</div>;
}

// Breadcrumb - wraps BackLink
interface BreadcrumbProps {
  to: string;
  label?: string;
}

function Breadcrumb({ to, label }: BreadcrumbProps) {
  return <BackLink to={to} label={label} />;
}

// Title container with actions support
interface TitleRowProps {
  children: ReactNode;
}

function TitleRow({ children }: TitleRowProps) {
  return <div className="flex items-start justify-between">{children}</div>;
}

// Title group (title + subtitle)
interface TitleGroupProps {
  children: ReactNode;
}

function TitleGroup({ children }: TitleGroupProps) {
  return <div>{children}</div>;
}

// Title - h1 element
interface TitleProps {
  children: ReactNode;
}

function Title({ children }: TitleProps) {
  return <h1 className="text-2xl font-bold text-gray-900 dark:text-dark-text">{children}</h1>;
}

// Subtitle - flexible content
interface SubtitleProps {
  children: ReactNode;
}

function Subtitle({ children }: SubtitleProps) {
  return <p className="text-sm text-gray-500 dark:text-dark-text-secondary mt-1">{children}</p>;
}

// Actions container
interface ActionsProps {
  children: ReactNode;
}

function Actions({ children }: ActionsProps) {
  return <div className="flex items-center gap-3">{children}</div>;
}

// Attach sub-components
PageHeader.Breadcrumb = Breadcrumb;
PageHeader.TitleRow = TitleRow;
PageHeader.TitleGroup = TitleGroup;
PageHeader.Title = Title;
PageHeader.Subtitle = Subtitle;
PageHeader.Actions = Actions;

export default PageHeader;
